define(['jquery', 'app/global'], function ($, global) {

  var $pagemapLinksGroups = global.cache.$body.find('.pagemap-links__group'),
    $columnLeft = $('<div class="pagemap-links__column"></div>'),
    $columnRight = $('<div class="pagemap-links__column"></div>');

  $pagemapLinksGroups.last().after($columnLeft);
  $columnLeft.after($columnRight);

  $pagemapLinksGroups.each(function () {
    var $this = $(this);
    if ($columnRight.outerHeight() > $columnLeft.outerHeight()) {
      $columnLeft.append($this);
    } else {
      $columnRight.append($this);
    }
  });

});



// WEBPACK FOOTER //
// ./_front/_inteligo/js/app/site-map.js